<template>
  <div class="restart-confirmation-modal">
    <div class="modal-backdrop" @click="cancel"></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-text">
          Are you sure you want to restart the chat from the beginning?
        </div>
        <button class="close-button" @click="cancel">
          <img :src="crossIcon" alt="Close modal"/>
        </button>
      </div>
      <div class="modal-actions">
        <button class="cancel-button" @click="cancel">Cancel</button>
        <button class="restart-button" @click="restart">Restart</button>
      </div>
    </div>
  </div>
</template>

<script>
import crossIcon from '../assets/images/cross-icon.svg';
import { CHATBOTS_GAINSIGHT_EVENTS, sendGainSightEvent } from '../../gainSightIntegration';
import { mapGetters } from 'vuex';

export default {
  name: 'RestartChatbotConfirmationModal',
  props: {
    conversationAttributes: {
      type: Object,
      default: null
    }
  },
  data() {
    return { crossIcon };
  },
  computed: {
    ...mapGetters({ hiverConfig: 'hiverConfig/getHiverConfig' })
  },
  methods: {
    cancel() {
      const ugId = this.hiverConfig.usergroup_id;
      const inboxId = this.conversationAttributes.inbox_id;
      this.$emit('cancel');
      sendGainSightEvent(CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_RESTART_CANCELED, {
        sm_id: inboxId,
        ug_id: ugId
      });
    },
    restart() {
      const ugId = this.hiverConfig.usergroup_id;
      const inboxId = this.conversationAttributes.inbox_id;
      this.$emit('restart');
      sendGainSightEvent(CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_RESTART_CONFIRMED, {
        sm_id: inboxId,
        ug_id: ugId
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.restart-confirmation-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content {
  width: 303px;
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 11;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.modal-text {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #343C45;
  flex: 1;
  padding-right: 10px;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  margin-top: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #0F13160A;
  }
  
  &:focus {
    outline: none;
  }
}

.close-icon {
  font-size: 24px;
  line-height: 1;
  color: #4D596C;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  
  button {
    padding: 4px 20px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s;
    width: 86px;
    
    &:focus {
      outline: none;
    }
  }
  
  .cancel-button {
    background-color: #fff;
    color: #506DFF;
    
    &:hover {
      background-color: #f0f3ff;
    }
  }
  
  .restart-button {
    background-color: #506DFF;
    color: white;
    
    &:hover {
      background-color: #4763f0;
    }
  }
}
</style>
